
import { create } from 'zustand';

// This store is used to prevent the bubbling of press events
// Must use setState() to update the store so that rerenders are not triggered
export const usePressBlockerStore = create(() => ({
  blocked: false,
  blockNextPress: () => {
    usePressBlockerStore.setState({ blocked: true });
    setTimeout(() => usePressBlockerStore.setState({ blocked: false }), 0);
  },
  isBlocked: () => usePressBlockerStore.getState().blocked,
}));
